export const workspaceIsInWorkspaceActivity = (workspaceActivity, workspace) => workspaceActivity.some((ws) => ws === workspace);

export const removeWorkspaceFromWorkspaceActivity = (workspaceActivity, workspace) => workspaceActivity.filter((ws) => ws !== workspace);
